import React from "react";
import "./ProcessStatusLoading.scss";

export function ProcessStatusLoading() {
  return <div class="process-status-loading"></div>;
}
